module.exports = __webpack_public_path__ + "img/gallery-icon.f37db018.svg";